import { render, staticRenderFns, recyclableRender, components } from "./pay-article-item.vue?vue&type=template&id=269ab0e4&scoped=true&"
var renderjs
import script from "./pay-article-item.vue?vue&type=script&lang=js&"
export * from "./pay-article-item.vue?vue&type=script&lang=js&"
import style0 from "./pay-article-item.vue?vue&type=style&index=0&id=269ab0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ab0e4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/pay-article-item/pay-article-item.vue"
export default component.exports